import { InputLabel, OutlinedInput, IconButton, FormControl, FormHelperText } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import { useState } from "react";

export const PasswordInput = (props) => {
    const { label, value, onChange, className, error, helperText } = props;
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    return (
        <FormControl variant="outlined" className={className}>
            <InputLabel sx={{
                backgroundColor: 'background.paper',
                px: 1,
                whiteSpace: 'normal',
                maxWidth: '100%',
                '&.MuiInputLabel-shrink': {
                    transform: 'translate(14px, -9px) scale(0.75)',
                    backgroundColor: 'background.paper',
                    px: 1,
                },
            }}>
                {label}
            </InputLabel>
            <OutlinedInput
                error={error}
                type={showPassword ? 'text' : 'password'}
                value={value}
                onChange={onChange}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
                label="Password"
            />
            {helperText && (
                <FormHelperText error>
                    {helperText}
                </FormHelperText>
            )}
        </FormControl>
    )
}